<script setup>
import SiteSidebar from '@/layouts/partials/SiteSidebar.vue';
import ConfirmationDialog from '@/layouts/partials/ConfirmationDialog.vue';
import SiteHeader from '@/layouts/partials/SiteHeader.vue';
import FullPageLoader from '@/layouts/partials/FullPageLoader.vue';
import OverlayProvider from '@/components/OverlayProvider.vue';
import GlobalSearch from '@/components/GlobalSearch.vue';
import { useGlobalSearchShortcut } from '@/composables/useGlobalSearchShortcut';
import { Toaster } from '@/components/ui/sonner';

useGlobalSearchShortcut();
</script>

<template>
    <Suspense>
        <template #default>
            <div class="flex grow">
                <SiteHeader />

                <SiteSidebar />

                <main class="relative z-0 flex min-w-0 grow flex-col bg-gray-50 pt-14 transition-all duration-500 ease-in-out md:pt-16 lg:pl-56">
                    <slot />
                </main>

                <GlobalSearch />
                <Toaster />
                <ConfirmationDialog />
                <OverlayProvider />
            </div>
        </template>
        <template #fallback>
            <FullPageLoader />
        </template>
    </Suspense>
</template>
